import useIsRecordedGoal from '@hooks/useIsRecordedGoal';
import { getIsSubscribedToLite } from '@selectors/subscription';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import Banner from './Banner';
import useReminderFetch from './useReminderFetch';

const Reminder = () => {
  const router = useRouter();
  const { goalUID } = router.query;
  const isRecordedGoal = useIsRecordedGoal(goalUID);

  const { isReminderSettingsAvailable } = useReminderFetch({
    validateStaleData: true
  });
  const isLiteUser = useSelector(getIsSubscribedToLite(goalUID));

  if (!isReminderSettingsAvailable || isLiteUser || isRecordedGoal) {
    return null;
  }

  return <Banner />;
};

export default Reminder;
